export const clientContactsListingRoutes = [
  {
    path: 'listing',
    name: 'clientcontact-listing',
    component: () =>
      import(/* webpackChunkName: "Clientcontact-listing" */ './ClientContactsListing.vue')
  }
];
